import { render, staticRenderFns } from "./ViewDocumentForms.vue?vue&type=template&id=4602a4e4&scoped=true"
import script from "./ViewDocumentForms.vue?vue&type=script&lang=js"
export * from "./ViewDocumentForms.vue?vue&type=script&lang=js"
import style0 from "./ViewDocumentForms.vue?vue&type=style&index=0&id=4602a4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602a4e4",
  null
  
)

export default component.exports